/** Odia IPA overrides for words not in the dictionary. */

export const or_: Record<string, string> = {
  // Bande Utkala Janani (Odia anthem)
  ଅଙ୍ଗେ: 'ɔŋɡe',
  // Jagannath Das — Odia Bhagabata
  ଅନାଦି: 'ɔnaːd̪i',
  ଅପ୍ରମିତ: 'ɔpɾɔmit̪ɔ',
  ଅର୍ଥେ: 'ɔɾt̪ʰe',
  ଅଶେଷ: 'ɔʃeʂɔ',
  ଆଗୁଁ: 'aːɡũ',
  ଆତ୍ମୀୟ: 'aːt̪miːjɔ',
  ଆରତ: 'aːɾɔt̪ɔ',
  // Gangadhar Meher — Tapaswinee
  ଆହ୍ଲାଦ: 'aːhl̪aːd̪ɔ',
  ଇନ୍ଦ୍ରନୀଳ: 'ind̪ɾɔniːl̪ɔ',
  ଉତ୍କଳଭୁବନେ: 'ut̪kɔl̪ɔbʱubɔne',
  ଉତ୍କଳର: 'ut̪kɔl̪ɔɾɔ',
  // Upendra Bhanja — Baidehisha Bilasa
  ଉଦ୍ଭବ: 'ud̪bʱɔbɔ',
  ଏଣେ: 'eɳe',
  ଔରସୁ: 'ɔwɾɔsu',
  // Rangabati (folk song)
  କନକଲତା: 'kɔnɔkɔl̪ɔt̪aː',
  କଳ: 'kɔl̪ɔ',
  କହଲୋ: 'kɔhɔl̪oː',
  କାତର: 'kaːt̪ɔɾɔ',
  // Fakir Mohan Senapati — Chha Mana Atha Guntha
  କାରବାର: 'kaːɾɔbaːɾɔ',
  କାରାଦଣ୍ଡେ: 'kaːɾaːd̪ɔɳɖe',
  କିମ୍ପା: 'kimpaː',
  କୃଷ୍ଣପାଦ: 'kɾuʂɳɔpaːd̪ɔ',
  କେବା: 'kebaː',
  କେଶା: 'keʃaː',
  କୋଶ: 'koːʃɔ',
  // Madhusudan Das — Utkala Santana
  ଗଙ୍ଗା: 'ɡɔŋɡaː',
  ଗଳୁଛି: 'ɡɔl̪ut͡ʃʰi',
  ଗୀତନାଦ: 'ɡiːt̪ɔnaːd̪ɔ',
  ଗୁଣାଳୟ: 'ɡuɳaːl̪ɔjɔ',
  ଗୁଁଥା: 'ɡũt̪ʰaː',
  ଗୋ: 'ɡoː',
  ଗୋଦାବରୀ: 'ɡoːd̪aːbɔɾiː',
  ଘଟେ: 'ɡʱɔʈe',
  ଘୁମୁସରଅଧିପ: 'ɡʱumusɔɾɔd̪ʱipɔ',
  ଚଳେ: 't͡ʃɔl̪e',
  ଚଳେନାହିଁ: 't͡ʃɔl̪enaːhĩ',
  ଚାରୁ: 't͡ʃaːɾu',
  ଚାଲିଯାଆନ୍ତୁ: 't͡ʃaːl̪ijaːaːnt̪u',
  ଜଗନ୍ନାଥେ: 'd͡ʒɔɡɔnnaːt̪ʰe',
  ଜନ୍ମକାଳରୁ: 'd͡ʒɔnmɔkaːl̪ɔɾu',
  ଜମିଦାର: 'd͡ʒɔmid̪aːɾɔ',
  ଜିତ: 'd͡ʒit̪ɔ',
  ଜ୍ୟୋତିର୍ମୟୀ: 'd͡ʒjoːt̪iɾmɔjiː',
  ତଦ୍ଧତ: 't̪ɔd̪d̪ʱɔt̪ɔ',
  ତନୁକାନ୍ତି: 't̪ɔnukaːnt̪i',
  ତରଙ୍ଗେ: 't̪ɔɾɔŋɡe',
  ତରିଲେ: 't̪ɔɾil̪e',
  ତାଗେ: 't̪aːɡe',
  ତୁହି: 't̪uhi',
  ତୋହର: 't̪oːhɔɾɔ',
  // Fakir Mohan Senapati — Odia Kahiki Daridra
  ଦରିଦ୍ରତା: 'd̪ɔɾid̪ɾɔt̪aː',
  ଦୀର୍ଘିକା: 'd̪iːɾɡʱikaː',
  ଦୀର୍ଘେ: 'd̪iːɾɡʱe',
  ଦୁଃଖ: 'd̪ukʱɔ',
  ଦୁର୍ଗତିର: 'd̪uɾɡɔt̪iɾɔ',
  ଦେଶବାସୀ: 'd̪eʃɔbaːsiː',
  ଦେଶମାଟିରେ: 'd̪eʃɔmaːʈiɾe',
  ଦ୍ୟୁତି: 'd̪jut̪i',

  ଧନଞ୍ଜୟ: 'd̪ʱɔnɔɲd͡ʒɔjɔ',
  ଧାନର: 'd̪ʱaːnɔɾɔ',
  ନ: 'nɔ',
  ନଗଦ: 'nɔɡɔd̪ɔ',
  ନନ୍ଦନ: 'nɔnd̪ɔnɔ',
  ନମଇଁ: 'nɔmɔĩ',
  ନର୍କେ: 'nɔɾke',
  ନାରୀଙ୍କ: 'naːɾiːŋkɔ',
  ନିରନ୍ତରେ: 'niɾɔnt̪ɔɾe',
  ନିହିତ: 'nihit̪ɔ',
  ନୀଳାମ୍ବୁ: 'niːl̪aːmbu',
  ନୃପ: 'nɾupɔ',
  ପଡ଼ିଥାଉ: 'pɔɖ̪it̪ʰaːu',
  ପଦୁ: 'pɔd̪u',
  ପଦେ: 'pɔd̪e',
  ପୟରେ: 'pɔjɔɾe',
  ପରା: 'pɔɾaː',
  ପୂର୍ବପୁରୁଷ: 'puːɾbɔpuɾuʂɔ',
  ପୋଷଣ: 'poːʂɔɳɔ',
  ପ୍ରଜ୍ଞା: 'pɾɔd͡ʒɲaː',
  ପ୍ରବନ୍ଧେ: 'pɾɔbɔnd̪ʱe',
  ପ୍ରାଣୀମାନଙ୍କ: 'pɾaːɳiːmaːnɔŋkɔ',
  ବନଭୂମି: 'bɔnɔbʱuːmi',
  ବନ୍ଦନ: 'bɔnd̪ɔnɔ',
  ବନ୍ଦେ: 'bɔnd̪e',

  ବରହିବଂଶେ: 'bɔɾɔhibɔŋʃe',
  ବର୍ଣ୍ଣଇ: 'bɔɾɳɳɔi',
  ବିଚାରେ: 'bit͡ʃaːɾe',
  ବିନୁ: 'binu',
  ବିବେକ: 'bibek',
  ବିଳାସ: 'bil̪aːsɔ',
  ବିଶିଷ୍ଟେ: 'biʃiʂʈe',
  ବିହଙ୍ଗେ: 'bihɔŋɡe',
  ବେନି: 'beni',
  ବେଶା: 'beʃaː',
  ବୋଲାଉ: 'boːl̪aːu',
  ବ୍ୟଥା: 'bjɔt̪ʰaː',
  ବ୍ରଜ: 'bɾɔd͡ʒɔ',
  ଭଣ୍ଡାର: 'bʱɔɳɖaːɾɔ',
  ଭାତୃଭାବ: 'bʱaːt̪ɾubʱaːbɔ',

  ଭାଷମୟୀ: 'bʱaːʂɔmɔjiː',
  ଭୀରୁ: 'bʱiːɾu',
  ଭୂଧରମାଳା: 'bʱuːd̪ʱɔɾɔmaːl̪aː',
  ଭେଦି: 'bʱed̪i',
  ମକରନ୍ଦ: 'mɔkɔɾɔnd̪ɔ',
  ମଙ୍ଗରାଜ: 'mɔŋɡɔɾaːd͡ʒɔ',
  ମନରେ: 'mɔnɔɾe',

  ମନୋହର: 'mɔnoːhɔɾɔ',
  ମଫସଲର: 'mɔpʰɔsɔl̪ɔɾɔ',
  ମରାଳମାଳିନୀ: 'mɔɾaːl̪ɔmaːl̪iniː',
  ମର୍ଯ୍ୟାଦା: 'mɔɾdʒjaːd̪aː',
  ମହାଜନ: 'mɔhaːd͡ʒɔnɔ',
  ମହାଜନୀ: 'mɔhaːd͡ʒɔniː',
  ମାଲେ: 'maːl̪e',
  ମିଶୁ: 'miʃu',
  ମୁଖରିତ: 'mukʱɔɾit̪ɔ',
  ରଙ୍ଗବତୀ: 'ɾɔŋɡɔbɔt̪iː',
  ରଜା: 'ɾɔd͡ʒaː',
  ରାଜିତ: 'ɾaːd͡ʒit̪ɔ',

  ରାନି: 'ɾaːni',
  ରୋଦନ: 'ɾoːd̪ɔnɔ',
  ଶୁଣାଯାଏ: 'ʃuɳaːjaːe',
  ଶୁଦ୍ଧ: 'ʃud̪d̪ʱɔ',
  ଶୁଭ: 'ʃubʱɔ',
  ଶୁଭ୍ର: 'ʃubʱɾɔ',
  ଶୋଭାର: 'ʃobʱaːɾɔ',
  ସପନ: 'sɔpɔnɔ',
  ସହୁ: 'sɔhu',
  ସାଜେ: 'saːd͡ʒe',

  ସୁତା: 'sut̪aː',
  ସୁପ୍ରକାଶ: 'supɾɔkaːʃɔ',
  ସେମାନଙ୍କଠାରେ: 'semaːnɔŋkɔʈʰaːɾe',
  ସୋଦର: 'soːd̪ɔɾɔ',
  ସ୍ଫୁର୍ତ୍ତି: 'spʰuɾt̪t̪i',
  ସ୍ୱାଧୀନ: 'swaːd̪ʱiːnɔ',
  ହାସମୟୀ: 'haːsɔmɔjiː',
  ହିତେ: 'hit̪e',
  ହୃଦୟରେ: 'hɾud̪ɔjɔɾe',
  ହୃଦେ: 'hɾud̪e',
  ହେଲ: 'hel̪ɔ',
  ହେଲାତ: 'hel̪aːt̪ɔ',
};
